import { axiosClient } from '@App/api/api-client'
import Pathes, { applyMultiSort, paginationPath2v } from '@App/dicts/pathes'
import { Maybe } from '@Types'
import { PaginationBody } from '@Entities/pagination'
import { ResultPage } from '@Entities/result-page'
import { OverclaimDocumentSearchResult } from '@Entities/overclaim/overclaim-document-search-result'
import {
    OverclaimUploadedDocument,
    OverclaimUploadedDocumentsForPublisher,
} from '@Entities/overclaim/overclaim-uploaded-document'
import { PresignedDocumentUpload } from '@Entities/document/document-to-upload'
import { OverclaimUploadDocumentDownloadResponse } from '@Entities/overclaim/overclaim-upload-document-download-response'

export const generateOverclaimDocumentUploadUrl = (
    rightsholderId: number,
    overclaimHeaderId: number,
    fileName: string,
    size: number,
    description: Maybe<string>,
    fileHash?: Maybe<string>
) =>
    axiosClient.post<PresignedDocumentUpload & { overclaimMemberUploadId: number }>(
        Pathes.RightsHolder.uploadDocumentForOverclaim(rightsholderId, overclaimHeaderId),
        { fileName, size, description, fileHash }
    )

export const generateBulkOverclaimDocumentUploadUrl = (
    rightsholderId: number,
    overclaimHeaderIds: number[],
    fileName: string,
    size: number,
    description: Maybe<string>,
    fileHash?: Maybe<string>
) =>
    axiosClient.post<PresignedDocumentUpload>(Pathes.RightsHolder.bulkUploadDocumentForOverclaims(rightsholderId), {
        uploadRequest: { fileName, size, description, fileHash },
        overclaimHeaderIds,
    })

export const updateOverclaimDocumentDescription = (
    rightsholderId: number,
    overclaimHeaderId: number,
    memberUploadId: number,
    updatedDescription: string
) =>
    axiosClient.put<OverclaimUploadedDocument>(
        Pathes.RightsHolder.updateOverclaimDocumentDescription(rightsholderId, overclaimHeaderId, memberUploadId),
        {
            description: updatedDescription,
        }
    )

export const getAllOverclaimUploadedDocumentsFor = (rightsholderId: number, overclaimHeaderId: number) =>
    axiosClient.get<OverclaimUploadedDocumentsForPublisher>(
        Pathes.RightsHolder.uploadDocumentForOverclaim(rightsholderId, overclaimHeaderId)
    )

export const getOverclaimUploadDocumentFor = (
    rightsholderId: number,
    overclaimHeaderId: number,
    memberUploadId: number
) =>
    axiosClient.get<OverclaimUploadDocumentDownloadResponse>(
        Pathes.RightsHolder.getOverclaimUploadDocumentDownload(rightsholderId, overclaimHeaderId, memberUploadId)
    )

interface SearchOverclaimDocumentsRequest {
    documentName?: string
    linkedOverclaimIds?: number[]
    workTitle?: string
    songCode?: string
}

export const searchOverclaimDocuments = (
    rightsholderId: number,
    overclaimId: number,
    pagination: PaginationBody,
    search: SearchOverclaimDocumentsRequest
) => {
    const url = new URL(
        Pathes.RightsHolder.searchOverclaimDocuments(rightsholderId, overclaimId) + paginationPath2v(pagination)
    )
    applyMultiSort(url, pagination)
    return axiosClient.post<ResultPage<OverclaimDocumentSearchResult>>(url.toString(), search)
}

export const attachExistingOverclaimDocument = (
    rightsholderId: number,
    overclaimHeaderId: number,
    documentId: number,
    description?: Maybe<string>
) =>
    axiosClient.post(Pathes.RightsHolder.attachExistingOverclaimDocument(rightsholderId, overclaimHeaderId), {
        memberUploadId: documentId,
        description,
    })
